export default "__VITE_PUBLIC_ASSET__b91f3aa2__"